import React from 'react';
import { Grid, Row } from 'react-flexbox-grid';
import classnames from 'classnames';
import TimelineCircle from '../timeline/TimelineCircle';

import base from '../../base.styl';
import styles from './Timeline.styl';

const Timeline = props => {
  let circles = [
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'top',
      year: '1973',
      info: 'The Endangered Species Act is signed into law by President Nixon'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'bottom',
      year: '1974',
      info: 'Gray wolves listed as Endangered on the ESA'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'top',
      year: '1978',
      info: 'Bald eagles listed on the ESA throughout the lower 48'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'bottom',
      year: '1987',
      info: 'Only remaining California condors rescued and captive bred'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'top',
      year: '1988',
      info: 'Mexican wolves reintroduced into the Southwest U.S.'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'bottom',
      year: '1992',
      info: 'California condors first reintroduced back into the wild'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'top',
      year: '1995',
      info: 'Gray wolves returned to Yellowstone National Park'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'bottom',
      year: '1995',
      info: 'Endangered Florida panthers saved by reintroduction program'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'top',
      year: '2007',
      info: 'Bald eagles achieve full recovery and removed from ESA'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'bottom',
      year: '2011',
      info: 'Congress strips ESA protection from some gray wolf populations'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'top',
      year: '2017',
      info: 'Congress introduces bills that would gut the ESA'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'big',
      position: 'bottom',
      year: '2019',
      info: 'Bills proposing to remove critical protections for keystone species are introduced in Congress. A bill to reverse recent anti-ESA policies is introduced in the U.S. House.',
      infoSize: 'large'
    },
    {
      color: '#007cf9',
      size: 'small'
    },
    {
      color: '#007cf9',
      size: 'small'
    }
  ];

  return (
    <div className={styles.timelineWrapper}>
      <div className={styles.gradientLine} />
      <Grid fluid className={classnames(base.container, styles.container)}>
        <Row between="xs" middle="xs" center="xs">
          {circles.map((circle, i) => {
            return <TimelineCircle key={i} circle={circle} />;
          })}
        </Row>
      </Grid>
    </div>
  );
};

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/timeline/Timeline.js